import { createGlobalStyle } from 'styled-components';
import fonts from '../fonts/proxima-nova-font-faces.css';
import { GeneralStyles, NormalizeGlobalStyle, OneTrustOverrides } from './_general';


const GlobalStyles = createGlobalStyle`
  ${NormalizeGlobalStyle}
  ${fonts}
  ${GeneralStyles}
  ${OneTrustOverrides}

  
  main.nav-open {
    margin-top: 208px; /* adjust as needed */
    transition: margin-top 0.3s ease;
  }
`;


export default GlobalStyles;